module.exports = __webpack_public_path__ + "static/media/successGreen.a555218f.svg";